import { render, staticRenderFns } from "./LabelHelp.vue?vue&type=template&id=5130fac4&scoped=true&"
import script from "./LabelHelp.vue?vue&type=script&lang=js&"
export * from "./LabelHelp.vue?vue&type=script&lang=js&"
import style0 from "./LabelHelp.vue?vue&type=style&index=0&id=5130fac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5130fac4",
  null
  
)

export default component.exports